import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Metabase } from '../_models/metabase.interface';

@Injectable({
  providedIn: 'root'
})
export class MetabaseService {

  private _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

  constructor(
    private _httpClient: HttpClient
  ) { }

  public getMetabaseDashboard$(customerID: string, dashboardID: string, dashboardType: string): Observable<Metabase> {
    return this._httpClient.get<Metabase>(`${this._kcmssvcURL}/customers/dashboard/${encodeURIComponent(String(customerID))}?id=${dashboardID}&type=${dashboardType}`)
    .pipe(
      map((data) => {
        if (!data || !data.data || !data.data.url) {
          throw new Error('No successful response');
        }
        return data;
      }),
    );;
  }
}
